<template>
  <div class="container">
    <h1>Reservaciones Mreced Rest Iniciar Sesión</h1>
    <form @submit.prevent="login">
      <div>
        <label for="email">Email:</label>
        <input type="email" v-model="email" id="email">
      </div>
      <div>
        <label for="password">Contraseña:</label>
        <input type="password" v-model="password" id="password">
      </div>
      <button type="submit">Iniciar Sesión</button>
    </form>
  </div>
</template>

<script>
import { auth } from '../firebase/init'
import { signInWithEmailAndPassword } from 'firebase/auth'
import { useRouter } from 'vue-router'

export default {
  name: 'AdminLogin',
  data() {
    return {
      email: '',
      password: ''
    }
  },
  setup() {
    const router = useRouter()
    return { router }
  },
  methods: {
    async login() {
      try {
        await signInWithEmailAndPassword(auth, this.email, this.password);
        localStorage.setItem('auth', 'true'); // Ajuste temporal para autenticación
        this.router.push('/admin');
      } catch (error) {
        console.error('Error al iniciar sesión:', error);
      }
    }
  }
}
</script>

<style scoped>
.container {
  max-width: 400px;
  margin: 0 auto;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background: #fff;
}

label {
  display: block;
  margin-top: 10px;
}

input, button {
  width: 100%;
  padding: 8px;
  margin-top: 5px;
}

button {
  margin-top: 20px;
  background-color: #007BFF;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

button:hover {
  background-color: #0056b3;
}
</style>
